import { render } from "./Report.vue?vue&type=template&id=6f8a436f"
import script from "./Report.vue?vue&type=script&setup=true&lang=js"
export * from "./Report.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Insights/Report.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f8a436f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f8a436f', __exports__)) {
    api.reload('6f8a436f', __exports__)
  }
  
  module.hot.accept("./Report.vue?vue&type=template&id=6f8a436f", () => {
    api.rerender('6f8a436f', render)
  })

}


export default __exports__